const updatePosition = (anchorEl, transformEl, cb) => {
  const {
    top,
    bottom,
    left,
    right
  } = anchorEl.getBoundingClientRect();
  const {
    innerHeight,
    innerWidth
  } = window;
  const {
    height: nodeHeight
  } = transformEl.getBoundingClientRect(); // Vertical

  if (bottom < 0 || top > innerHeight) {
    cb();
  } else if (bottom + 4 + nodeHeight > innerHeight) {
    if (top - (nodeHeight + 4) > 0) {
      transformEl.style.top = top - (nodeHeight + 4) + 'px';
    } else {
      transformEl.style.top = innerHeight - nodeHeight + 'px';
    }
  } else {
    transformEl.style.top = bottom + 4 + 'px';
  } // Horizontal


  if (left < 0 || right > innerWidth) {
    cb();
  } else {
    transformEl.style.left = left + 'px';
  }
};

export default updatePosition;